module.exports = __webpack_public_path__ + "img/mobile-index.83de90b0.png";